module.exports = __webpack_public_path__ + "static/img/tech02.21ea902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tech02.png
// module id = Zx72
// module chunks = 3 4